//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import toggleSwitchTemplate from '@partials/toggle-switch.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('toggleSwitch', {
    bindings: {
      toggleName: '@',
      toggleDisabled: '<',
      toggleIsActive: '<',
      toggledCallback: '&',
      tt: '@?',
    },
    template: toggleSwitchTemplate,
    controller: [
      function() {
        const self = this;

        this.toggleState = function() {
          self.toggledCallback({ state: !self.toggleIsActive });
        };
      },
    ],
  });
})();
